import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-image-overlays" }

import { type PropType } from "vue";
import ImageOverlay from "../../../commons/product/overlays/image-overlay.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'product-image-overlays',
  props: {
    product: {
        type: Object as PropType<{
            overlayTextType: string | null | undefined;
            overlayTextLink?: string | null | undefined;
            overlayText: string | null | undefined;
            stampType: string | null | undefined;
        }>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.product.overlayText != null)
      ? (_openBlock(), _createBlock(ImageOverlay, {
          key: 0,
          type: __props.product.overlayTextType ?? undefined
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.product.overlayText), 1 /* TEXT */)
          ], undefined, true),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["type"]))
      : _createCommentVNode("v-if", true),
    (__props.product.stampType === 'thirdparty')
      ? (_openBlock(), _createBlock(ImageOverlay, {
          key: 1,
          type: "third-party-stamp"
        }))
      : (__props.product.stampType === 'related-auction')
        ? (_openBlock(), _createBlock(ImageOverlay, {
            key: 2,
            type: "related-auction",
            link: __props.product.overlayTextLink
          }, null, 8 /* PROPS */, ["link"]))
        : (__props.product.stampType === 'related-shop')
          ? (_openBlock(), _createBlock(ImageOverlay, {
              key: 3,
              type: "related-shop",
              link: __props.product.overlayTextLink
            }, null, 8 /* PROPS */, ["link"]))
          : _createCommentVNode("v-if", true)
  ]))
}
}

})